'use client';

import {
    isServer,
    QueryClient,
    QueryClientProvider,
} from '@tanstack/react-query';
import { ReactNode } from 'react';

import { FormatProvider } from '@/contexts/i18n/format';
import * as Tooltip from '@/ui/Tooltip';

function makeQueryClient() {
    return new QueryClient({
        defaultOptions: {
            queries: {
                staleTime: 60 * 1000,
            },
        },
    });
}

let browserQueryClient: QueryClient | undefined = undefined;

function getQueryClient() {
    if (isServer) {
        return makeQueryClient();
    } else {
        if (!browserQueryClient) {
            browserQueryClient = makeQueryClient();
        }

        return browserQueryClient;
    }
}

export function RootProviders({
    children,
    locale,
}: {
    children: ReactNode;
    locale: string;
}) {
    const queryClient = getQueryClient();

    return (
        <FormatProvider locale={locale}>
            <Tooltip.Provider>
                <QueryClientProvider client={queryClient}>
                    {children}
                </QueryClientProvider>
            </Tooltip.Provider>
        </FormatProvider>
    );
}
